<script setup lang="ts">
/**
 * The line under a job posting field that took a link (usePostingFromUrl):
 * reading the page, read from it, or why it could not be read.
 */
const props = defineProps<{
  isLoading: boolean
  error: string
  loadedFrom: string | null
  /** Replaces the general "you can paste just the link" tip while nothing is loading. */
  hint?: string
}>()

const { t } = useI18n()

const host = computed(() => {
  if (!props.loadedFrom) return ''
  try {
    return new URL(props.loadedFrom).hostname.replace(/^www\./, '')
  } catch {
    return props.loadedFrom
  }
})
</script>

<template>
  <p v-if="isLoading" class="mt-1.5 flex items-center gap-1.5 !text-xs !text-muted dark:!text-gray-400" role="status">
    <span class="size-3 animate-spin rounded-full border-2 border-current border-t-transparent" aria-hidden="true" />
    {{ t('postingUrl.loading') }}
  </p>
  <p v-else-if="error" class="mt-1.5 !text-xs !text-red-600 dark:!text-red-400" role="alert">{{ error }}</p>
  <p v-else-if="loadedFrom" class="mt-1.5 !text-xs !text-muted dark:!text-gray-400" role="status">
    <i class="bi bi-link-45deg !text-accent" aria-hidden="true" />
    {{ t('postingUrl.loaded', { host }) }}
  </p>
  <p v-else class="mt-1.5 !text-xs !text-muted dark:!text-gray-500">{{ hint || t('postingUrl.hint') }}</p>
</template>
